import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { map } from 'rxjs/operators';
import { DataTypeComponent } from '../../../data-type-component';
import { AdminGaugeDO, FieldConfigDTO } from '../../../../../../system/system-dtos';
import { EnvironmentService } from '../../../../../../common/services/env-configuration/environment.service';
import { BlastV2Service } from '../../../../../views/main-table-v2/service/blast-v2.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-form-field-metric',
  templateUrl: './metric-form-field.component.html',
  standalone: false,
})
export class MetricFormFieldComponent extends DataTypeComponent {
  @Input() formGroup: UntypedFormGroup;

  @Input() fieldConfig: FieldConfigDTO;

  @Input() data: any;

  @Input() editMode: boolean;

  constructor(
    private environmentService: EnvironmentService,
    private changeDetectorRef: ChangeDetectorRef,
    private blastService: BlastV2Service
  ) {
    super();
  }

  ngAfterViewInit() {
    this.blastService
      .getCollectionObservable('GAUGES_METRICS')
      .pipe(map((d) => d.find((g: AdminGaugeDO) => g.name === this.fieldConfig.metricOptions.name)))
      .subscribe((d) => {
        this.data = d && d.value;
        this.changeDetectorRef.detectChanges();
      });

    /* this.cacheService.attachedWatcher
            .pipe(map(() => this.cacheService.getCacheData('GAUGES_METRICS')
                .find((g: AdminGaugeDO) => g.name === this.fieldConfig.metricOptions.name)))
            .subscribe((d: AdminGaugeDO) => {
                if (d !== undefined && d !== null) {
                    this.data = d.value;
                    this.changeDetectorRef.detectChanges();
                }
            }); */
  }
}
